// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1LA44","header":"ReportDetails_header__24Vtb","title":"ReportDetails_title__1eRNF","left":"ReportDetails_left__2NnS7"};